import { App } from 'antd';
import { useMemo } from 'react';
import { createToastApi, type ToastApi } from '../utils/toast';

export type { ToastApi } from '../utils/toast';

export function useToast(): ToastApi {
  const { message } = App.useApp();
  return useMemo(() => createToastApi(message), [message]);
}
